import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../context/GlobalContext';

/**
 * Custom hook for authentication related functionality
 * Provides methods for logout and handling tenant data
 */
export const useAuth = () => {
  const navigate = useNavigate();
  const { clearContext, updateTenantData } = useGlobalContext();

  /**
   * Handle user logout
   * Clears localStorage, global context, and redirects to signin page
   */
  const handleLogout = () => {
    // Clear localStorage items
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('tenantId');
    window.localStorage.removeItem('uid');
    window.localStorage.removeItem('role');
    
    // Clear global context
    clearContext();
    
    // Redirect to signin page
    navigate('/signin');
  };

  /**
   * Set tenant data in global context
   * @param tenantData - The tenant data object
   */
  const setTenantData = (tenantData: any) => {
    if (!tenantData) return;
    
    // Update global context with tenant data
    updateTenantData(tenantData);
    
    // Store tenantId in localStorage for persistence
    if (tenantData.tenantId) {
      window.localStorage.setItem('tenantId', tenantData.tenantId);
    }
  };

  return {
    handleLogout,
    setTenantData
  };
};
